import * as React from "react";
import { TextBoxWithStaticPrefix } from "../../../forms/informedv2/TextBoxWithStaticPrefix";
import { CFCardSerialValidator } from "../../../forms/validation/CFCardSerialValidator";

export interface MediaSerialInputProps {
    id: string;
    field: string;
    staticPrefix: string;
    value: string;
    disabled?: boolean;
    onChange?;
}

export const MediaSerialInput = ({
    id,
    field,
    staticPrefix,
    value,
    disabled,
    onChange
}: MediaSerialInputProps) => {
    // Check for single prefix also just to be safe
    const singleStaticPrefix = /^(.)\1+$/.test(staticPrefix) ? staticPrefix.substring(0, 1) : staticPrefix;

    const valueWithoutPrefix = value ? value.replace(new RegExp(`${singleStaticPrefix}`, 'g'), "") : value;

    return (
        <TextBoxWithStaticPrefix
            id={id}
            field={field}
            staticpart={staticPrefix}
            initialValue={valueWithoutPrefix}
            type="number"
            placeholder="#####"
            pattern="\d{4,5}"
            validate={CFCardSerialValidator}
            disabled={disabled}
            onChange={onChange}
        />
    );
};
